module.exports = __webpack_public_path__ + "img/success.082c2548.png";